import { RecipePage } from "./recipePage";
import { data } from "../data/recipeData";
import { getOneByClass } from "../util";
import { Recipe } from "../data/recipeModel";
import { sounds } from "../soundManager";

export class RecipeBook {
    div: HTMLElement;
    pages: RecipePage[] = [];
    currentIndex = -1;

    public get currentPage() {
        return this.pages[this.currentIndex];
    }

    constructor() {
        this.populateRecipes();
    }

    populateRecipes() {
        for (let recipe of data) {
            this.pages.push(new RecipePage(recipe));
        }
    }

    getPage(recipe: Recipe) {
        return this.pages.find(p => p.recipe === recipe);
    }

    createElement() {
        this.div = getOneByClass("recipe-book");
        getOneByClass("left").onclick = () => this.pageLeft(); // TODO this.div
        getOneByClass("right").onclick = () => this.pageRight();

        this.switchToNewPage(0);
    }

    switchToNewPage(index: number) {
        if (index != this.currentIndex) {
            this.currentIndex = index;
            this.currentPage.showOnPage();
            this.updateButtons();
        }
    }

    pageLeft() {
        if (this.currentIndex > 0) {
            this.switchToNewPage(this.currentIndex - 1);
            sounds.play("page2");
        }
    }

    pageRight() {
        if (this.currentIndex < this.pages.length - 1) {
            this.switchToNewPage(this.currentIndex + 1);
            sounds.play("page");
        }
    }

    // Although we could (unrealistically) cycle
    updateButtons() {
        const left = getOneByClass("left") as HTMLButtonElement;
        const right = getOneByClass("right") as HTMLButtonElement;
        left.disabled = this.currentIndex < 1;
        right.disabled = this.currentIndex > this.pages.length - 2;
    }

    updateTotal() {
        this.currentPage.updateTotal();
    }
}